module.exports = __webpack_public_path__ + "media/mascot/mascot2-55d850e1.png";